<template>
  <v-card class="pa-3 main-grid" :loading="isLoading" :disabled="isLoading">
    <v-col>
      <v-form ref="searchForm" v-model="validForm" @submit.prevent="submitForm">
        <v-row justify="space-between">
          <v-col
            cols="12"
            md="4"
            class="py-0 align"
            :order="this.$vuetify.breakpoint.mdAndUp ? '1' : '2'"
          >
            <product-area
              v-model="document.productArea"
              :product-area-value="document.productArea"
              has-all-option
              class="mx-3"
            ></product-area>
          </v-col>
          <v-col
            md="4"
            class="py-0"
            :class="`d-flex justify-end`"
            :order="this.$vuetify.breakpoint.mdAndUp ? '2' : '1'"
          >
            <v-btn
              v-if="isAuthorized"
              class="mr-3 mt-4 mb-2"
              @click.stop="logoutClick"
            >
              Logout
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" class="py-0">
            <brand-dropdown
              v-model="document.brand"
              :brand-value="document.brand"
              :rules="brandRules"
              has-all-option
              class="mx-3"
            ></brand-dropdown>
          </v-col>
          <v-col cols="12" md="4" class="py-0">
            <document-type-dropdown
              v-model="document.docType"
              :doc-type-value="document.docType"
              has-all-option
              class="mx-3"
            ></document-type-dropdown>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="4" class="py-0">
            <v-tooltip top :disabled="document.region !== 0">
              <template v-slot:activator="{ on, attrs }">
                <div class="mx-3" v-bind="attrs" v-on="on">
                  <language-dropdown
                    v-model="document.language"
                    :language-value="document.language"
                    :region-filter="document.region"
                    :disabled="document.region === 0"
                    has-all-option
                  ></language-dropdown>
                </div>
              </template>
              <span>Choose Region to provide language options</span>
            </v-tooltip>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" md="8" class="pt-0">
            <v-text-field
              v-model="searchString"
              label="Search"
              hint="Please include the full spelling in your search, including hyphens. For example, Hem-o-lok or EZ-IO"
              append-icon="mdi-magnify"
              hide-details="auto"
              class="mx-3"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row class="px-3">
          <v-btn color="error" class="mr-3 mb-1" @click.stop="resetForm"
            >Clear</v-btn
          >
          <v-btn
            type="button"
            color="primary mb-1"
            @click.stop="submitForm(true)"
          >
            Search
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn
            v-if="isAuthorized && !isIE"
            color="success"
            class="mb-1"
            @click.stop="newDocument"
          >
            <v-icon class="mr-2">mdi-text-box-plus-outline</v-icon>Add Document
          </v-btn>
        </v-row>
      </v-form>
    </v-col>
  </v-card>
</template>

<script>
import router from '../router';
import productArea from '@/components/filters/productArea';
import languageDropdown from '@/components/filters/languageDropdown';
import brandDropdown from '@/components/filters/brandDropdown';
import documentTypeDropdown from '@/components/filters/documentTypeDropdown';
import { mapMutations, mapActions, mapState } from 'vuex';
import { queryBuilder, parseQueryParams } from '@/store/modules/queryHelper.js';

export default {
  components: {
    productArea,
    languageDropdown,
    brandDropdown,
    documentTypeDropdown
  },
  data() {
    return {
      validForm: true,
      searchString: '',
      isLoading: false,
      document: {
        productArea: 0,
        brand: [0],
        region: 1,
        language: '',
        docType: 0
      },
      brandRules: [v => v.length > 0 || 'Please select a brand']
    };
  },
  computed: {
    ...mapState('user', ['isAuthorized']),
    ...mapState(['isIE']),
    axiosParams() {
      let params = new URLSearchParams();
      params.append('region', this.document.region);
      params.append('language', this.document.language);
      params.append('productArea', this.document.productArea);
      params.append('brand', this.document.brand);
      params.append('docType', this.document.docType);
      params.append('searchString', this.searchString);
      return params;
    }
  },
  created() {},
  mounted() {
    this.setSearchLanguage('');
    if (JSON.stringify(this.$route.query) != '{}') {
      parseQueryParams(
        this.$route.query,
        this.document,
        this.searchString
      ).then(searchString => {
        this.searchString = searchString;
        this.submitForm(false);
      });
    }
  },
  methods: {
    ...mapMutations(['toggleResults']),
    ...mapMutations('languages', ['setSearchLanguage']),
    ...mapActions('documents', ['getDocuments']),
    ...mapActions('user', ['logout']),
    resetForm() {
      this.document.productArea = 0;
      this.document.region = 1;
      this.document.language = '';
      this.document.brand = [0];
      this.document.docType = 0;
      this.searchString = '';
    },
    submitForm(pushRoute) {
      if (this.$refs.searchForm.validate()) {
        var query = queryBuilder(this.document, this.searchString);
        if (pushRoute && this.$router.history.current.fullPath != query) {
          this.$router.push({
            path: `${query}`
          });
        }
        this.isLoading = true;
        this.getDocuments(this.axiosParams).then(() => {
          this.isLoading = false;
        });
      }
    },
    newDocument() {
      router.push({ name: 'mciVerify' });
    },
    clearProductRange() {
      this.document.productRange = 0;
    },
    logoutClick() {
      this.logout();
    }
  }
};
</script>

<style scoped>
.search-field {
  max-width: 400px;
}
.main-grid {
  /* background-color: whitesmoke; */
  min-width: 100%;
}
</style>
